/**
 * Shopify Markets / locale-aware storefront root (e.g. "/en/" or "/").
 * Bare "/cart.js" returns the shop primary language; prefixed URLs match the visitor locale.
 */
export function getShopifyRoutesRoot() {
  const root =
    (typeof window !== "undefined" && window?.Shopify?.routes?.root) || "/";
  return root.endsWith("/") ? root : `${root}/`;
}

/**
 * @param {string} path - e.g. "cart.js", "cart/change.js", "cart/add.js"
 */
export function getShopifyCartUrl(path) {
  const clean = String(path || "").replace(/^\//, "");
  return `${getShopifyRoutesRoot()}${clean}`;
}
